<template lang="pug">
  svg(
    version="1.1"
    id="Press"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 820 857"
    style="enable-background:new 0 0 820 857;"
    xml:space="preserve"
  )
    path(
      id="SVGID_x5F_1_x5F_"
      class="st0"
      d="M446.2,845.8C222.5,864.6,25.1,697.9,6.3,474.2S154.3,53.2,378,34.4S799,182.3,817.8,406 C836.6,629.7,669.9,827,446.2,845.8z"
    )
    text
      textPath(
        xlink:href="#SVGID_x5F_1_x5F_"
        startOffset="59.147%"
      )
        tspan(
          style="fill:#FFFFFF;font-family:'Courier';font-size:40px;"
        )
          | PRESS YOUR KEYBOARD
</template>

<script>

export default {
  name: "PressKey"
};
</script>

<style lang="sass">
  .st0
    fill: none
</style>
